import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";
import DetalhesDoPedidoFluxoViewModel from "@/shared/view-models/DetalhesDoPedidoFluxoViewModel";
import PedidoDetalhesViewModel from "@/shared/view-models/PedidoDetalhesViewModel";
import GerarNovoPedidoCaracteristicasViewModel from "@/shared/view-models/GerarNovoPedidoCaracteristicasViewModel";
import PedidoEmAndamentoPDF from "./PDF/PedidoEmAndamentoPDF.vue";
import Tools from "@/shared/services/tools";
import novaEmbalagemViewModel from "@/shared/view-models/Filtros/NovaEmbalagemViewModel";

const name = 'DetalhesPedidoEmAndamento'

export default {
  name,

  components:{
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
    PedidoEmAndamentoPDF
  },

  props: { },

  mounted() {
    this.getDetalhesDoPedido()
    this.getDetalhesGeraisDoPedido()
    this.getCaracteristicasDoGerarNovoPedido()
    // this.getEmbalagemColetiva()
    this.GetParcelas()
    this.getLog()
   },

  updated() { },

  data() { 
    return {
      detalhesDoPedidoFluxo : new DetalhesDoPedidoFluxoViewModel(),
      novoPedidoDetalhes : new PedidoDetalhesViewModel(),
      novaEmbalagem : new novaEmbalagemViewModel(),
      caracteristicasPedido : new GerarNovoPedidoCaracteristicasViewModel(),
      embalagensArray:[],
      OrcamentoId: null,
      fsc: null,
      ComponentePedidoArray:[],
      ObsArray: [],
      executarvisualizacao: 0,
      linhaSelecionada: {},
      pdfdownload: false,
      pdfvisualizacao: false,
      PedidoId: null,
      renderiza: false,
      parcelasInfo:[],
      ColunaMedidas: null,
      caminhoImagem: null,
      styleImg: null,
      podeGerarPdf: false
    }
  },

  methods: {
    formataDecimal(valor){
      return Tools.valorDecimalFormatado(valor)
    },

    formataMonetario(valor){ 
      return Tools.valorMonetario4Digitos(valor)
    },

    voltar() {
      switch(this.detalhesDoPedidoFluxo.Status){ 
        case 11:
          this.$router.push(`/pedido-em-fase-digitacao`);
        break
        case 4:
          this.$router.push(`/andamento-de-pedidos`);
        break
        case 5 || 6:
          this.$router.push(`/pedido-cancelado-liquidado`);
        break
        case 13:
          this.$router.push(`/pedido-expedido-faturado`);
        break
      }
    },

    getLog() {
      this.axios({
        method: "get",
        url:
          process.env.VUE_APP_WEB_API +
          `Pedido/GetLog/`,
      }).then(() => {

      })
    },

    getDetalhesDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.detalhesDoPedidoFluxo, Tools.captalizeKeys(response.data.data))
        })
        .catch(() => {
        });
    },

    getEmbalagemColetiva() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByOrcamentoId/${this.$route.params.id}`,
      })
        .then((response) => {
          Tools.objectCustomAssign(this.novaEmbalagem, Tools.captalizeKeys(response.data.data))
          this.OrcamentoId = this.novaEmbalagem.OrcamentoId;

          // this.novaEmbalagem.ImpressaoDescricao !== null ? this.ObsArray.push(this.novaEmbalagem.ImpressaoDescricao) : ''
          // this.novaEmbalagem.DescricaoVisual !== null ? this.ObsArray.push(this.novaEmbalagem.DescricaoVisual) :''
          // this.novaEmbalagem.FacaMedidaDescricao !== null ? this.ObsArray.push(this.novaEmbalagem.FacaMedidaDescricao) : ''
          // this.novaEmbalagem.FacaSistemaDescricao !== null ? this.ObsArray.push(this.novaEmbalagem.FacaSistemaDescricao) :''
          this.InformacoesOrcamentoComponenteByOrcamentoId();
        })
    },

    GetParcelas() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetParcelasPedidos/${this.$route.params.id}`,
      })
        .then((response) => {
          this.parcelasInfo = response.data.data;
            // this.axios({
            //   method: 'get',
            //   url: process.env.VUE_APP_WEB_API + `Pedido/GetComponentesParcelasPedidos/${this.$route.params.id}`,
            // })
            //   .then((response) => {
            //     this.componentesInfo = response.data.data;
            //   })
            //   .catch(() => {
            //   });
        })
        .catch(() => {
        });
    },


    getDetalhesGeraisDoPedido() {
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetDetalhesGeraisDoPedidoFluxo/${this.$route.params.id}`,
      })
        .then((response) => {
          /*eslint-disable*/
          
          Tools.objectCustomAssign(this.novoPedidoDetalhes, Tools.captalizeKeys(response.data.data))
          this.OrcamentoIdCerto = this.novoPedidoDetalhes.OrcamentoId;

          this.novoPedidoDetalhes.ImpressaoDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.ImpressaoDescricao) : ''
          this.novoPedidoDetalhes.DescricaoVisual !== null ? this.ObsArray.push(this.novoPedidoDetalhes.DescricaoVisual) :''
          this.novoPedidoDetalhes.FacaMedidaDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.FacaMedidaDescricao) : ''
          this.novoPedidoDetalhes.FacaSistemaDescricao !== null ? this.ObsArray.push(this.novoPedidoDetalhes.FacaSistemaDescricao) :''
          this.InformacoesOrcamentoComponenteByOrcamentoId();
        })
        .catch(() => {
        });
    },


    getCaracteristicasDoGerarNovoPedido() {
      this.$isLoading(true)
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Pedido/GetCaracPedidoFluxo/${this.$route.params.id}`,
        data: {
          PedidoId: this.$route.params.id
        }
      })
        .then((response) => {
          Tools.objectCustomAssign(this.caracteristicasPedido, Tools.captalizeKeys(response.data.data))
        }).finally(() => this.$isLoading(false))
    },



    InformacoesOrcamentoComponenteByOrcamentoId(){
      this.axios({
        method: 'get',
        url: process.env.VUE_APP_WEB_API + `Componente/GetComponentesByOrcamentoId/${this.OrcamentoIdCerto}`,
      })
      .then((response) => {
        this.ComponentePedidoArray = response.data.data
        this.novaEmbalagem = response.data.data
        this.ComponentePedidoArray.forEach((r)=>{

          r.ColunaMedidas = `${r.numeroComprimento} x ${r.numeroLargura} x  ${r.numeroAltura} x ${r.numeroAlturaTampa}`
          return this.ColunaMedidas = r.ColunaMedidas
        })
        this.embalagensEspecificas()
      })
      .catch(() => {
      });
    },

    
    embalagensEspecificas(){
      this.ComponentePedidoArray.forEach((r)=>{
        r.embalagens = []
        r.embalagemEspecificaFilmeEncolhivel ? r.embalagens.push('Filme encolhível: ' + `${r.quantidadeFilmeEncolhivel}`) : ''
        r.embalagemEspecificaCaixaColetiva ? r.embalagens.push('Caixa Coletiva: ' + `${r.quantidadeCaixaColetiva}`) : ''
        r.embalagemEspecificaPalete  ? r.embalagens.push('Palete: ' + `${r.quantidadePalete}`) : ''
        r.embalagemEspecificaPapelEmbrulho  ? r.embalagens.push('Papel Embrulho: ' + `${r.quantidadePapelEmbrulho}`) : ''
        r.quantidadeOutros ? r.embalagens.push('Outros: ' + `${r.quantidadeOutros}`) : ''
  })
  },


    imprimir() {
      this.renderiza = true
      this.PedidoId = this.$route.params.id
      
      if(this.podeGerarPdf) {
        this.executarvisualizacao++
      }
    },

    gerarPdf() {
      setTimeout(() => {
        this.executarvisualizacao++
      }, "500");
    }
  },

  computed: { }
};